var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "unified-navigation-ui": "static-1.26881",
      "ably-hubspot-js": "static-2.3447",
      "breadcrumbs-ui": "static-1.2067",
      "client-types": "static-1.375",
      "enviro": "static-4.306",
      "head-dlb": "static-1.4043",
      "hs-lodash": "static-4.45",
      "hs-promise-utils": "static-1.4397",
      "hs-test-utils": "static-1.6881",
      "hub-http": "static-1.4807",
      "hubspot-url-utils": "static-1.3217",
      "HubStyleTokens": "static-2.10371",
      "I18n": "static-7.1393",
      "jasmine-runner": "static-1.5273",
      "nav-client-types": "static-1.1210",
      "nav-meta": "static-1.25674",
      "navigation-components": "static-1.14037",
      "navigation-components-tests": "static-1.10647",
      "navigation-messaging": "static-1.3364",
      "quartz": "static-1.5629",
      "react": "static-7.151",
      "react-dnd": "static-2.33",
      "react-dnd-html5-backend": "static-2.10",
      "react-redux": "static-7.16",
      "redux": "static-4.16",
      "rpc-client-utils": "static-1.3585",
      "target-element-observer": "static-1.1108",
      "trials-service-types": "static-1.2966",
      "webpack-env": "static-1.54",
      "wootric-nps": "static-1.5792",
      "ably": "static-2.2",
      "calling-internal-common": "static-1.30106",
      "classnames": "static-2.10",
      "crosstab": "static-1.3478",
      "ExtensionInstallHelpers": "static-1.538",
      "foundations-assets": "static-1.3795",
      "foundations-components": "static-1.6080",
      "foundations-theming": "static-1-rd-fix-namespaceplugin.53",
      "foundations-theming-base": "static-1-rd-fix-namespaceplugin.53",
      "foundations-theming-specialty": "static-1-rd-fix-namespaceplugin.53",
      "frontend-preferences-client": "static-1.6740",
      "global-search-externals": "static-1.11693",
      "idb-keyval": "static-1.21",
      "magpie-lib": "static-1.4539",
      "magpie-types": "static-1.3999",
      "metrics-js": "static-1.8647",
      "nav-onboarding-tours": "static-1.2388",
      "notification-sounds": "static-1.3303",
      "prefetcher": "static-1.4645",
      "react-dom": "static-7.85",
      "react-utils": "static-2.4379",
      "redux-thunk": "static-2.43",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "sanitize-text": "static-1.7045",
      "simple-logging-lib": "static-1.1910",
      "styled-components": "static-2.64",
      "superstore": "static-1.3644",
      "trial-components-library": "static-1.11039",
      "ts-schema": "static-1.3190",
      "ui-images": "static-2.857",
      "usage-tracker-core": "static-1.6196",
      "hs-promise-rejection-tracking": "static-1.4356",
      "PortalIdParser": "static-2.284",
      "raven": "static-3.4818",
      "raven-hubspot": "static-1.5125",
      "bend-plugin-trellis-migration": "static-1.2509",
      "moment": "static-3.26",
      "quartz-core": "static-1.4848",
      "storybook-react": "static-1.4",
      "HeadJS": "static-2.579",
      "framer-motion": "static-1.41",
      "hs-test-utils-bend-plugin": "static-1.1992",
      "msw": "static-1.39",
      "testing-library": "static-1.121",
      "i18n-data": "static-1.198",
      "moment-timezone": "static-5.51",
      "jasmine": "static-4.3215",
      "quartz-core-utils": "static-1.2496",
      "StyleGuideUI": "static-3.463",
      "csstype": "static-1.38",
      "hoist-non-react-statics": "static-3.9",
      "quick-fetch": "static-1.2772",
      "HubStyle": "static-2.10679",
      "calling-error-reporting": "static-1.30112",
      "calling-usage-tracker": "static-1.5365",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "self-service-api": "static-1.9078",
      "SharedI18nStrings": "static-1.162",
      "UIComponents": "static-3.7318",
      "hs-story-utils": "static-1.8261",
      "bend-plugin-foundations-components": "static-1.2349",
      "floating-ui": "static-1.29",
      "react-aria": "static-1.39",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.74",
      "tanstack-table": "static-1.23",
      "ui-fonts": "static-1.332",
      "bend-plugin-foundations-theming": "static-1-rd-fix-namespaceplugin.53",
      "hub-http-janus": "static-1.651",
      "global-search-shared": "static-1.12408",
      "usage-tracker": "static-1.6346",
      "autolinker": "static-3.11",
      "sanitize": "static-1.3257",
      "transmute": "static-2.29",
      "ai-components-ui-library": "static-1.5340",
      "atom": "static-1.4069",
      "copilot-toolkit": "static-1.6748",
      "demographics-client": "static-1.4277",
      "hubs-service-types": "static-1.337",
      "icons": "static-2.592",
      "laboratory-lib": "static-3.6122",
      "onboarding-scopes": "static-1.5433",
      "react-input-autosize": "static-2.17",
      "salesImages": "static-1.501",
      "signup-constants": "static-1.16435",
      "ui-addon-i18n": "static-1.9792",
      "ui-addon-upgrades": "static-9.16127",
      "user-context": "static-1.4047",
      "dispatcher": "static-1.113",
      "general-store": "static-6.20",
      "history": "static-4.47",
      "hub-http-shared-msw-handlers": "static-1.7146",
      "hubspotter-http": "static-1.3638",
      "hubspotter-http-shared-msw-handlers": "static-1.7144",
      "mobile-manifest-mixins": "static-1.350",
      "platform-navigation-bootstrap": "static-1.11286",
      "react-rhumb": "static-1.15451",
      "react-router-dom": "static-5.26",
      "cssUtils": "static-1.507",
      "customer-data-ui-utilities": "static-1.8594",
      "ai-addon-copilot-preview": "static-1.4552",
      "apollo-link-hub-http": "static-2.3648",
      "apollo-stack-hubspot": "static-3.43",
      "data-fetching-client": "static-1.8484",
      "graphql": "static-1.59",
      "search-service-types": "static-1.2836",
      "chatspot-client-types": "static-1.8727",
      "chatspot-core": "static-1.15992",
      "ContentUtils": "static-1.63613",
      "sassPrefix": "static-1.132",
      "foundations-components-test-utils": "static-1.3565",
      "feature-store-service-types": "static-1.3558",
      "growth-monetization-service-types": "static-1.3565",
      "upgrade-management-service-types": "static-1.3549",
      "getting-started-shared-tasks": "static-1.13116",
      "getting-started-shared-tasks-store": "static-1.12234",
      "platform-infra-nav-components": "static-1.6750",
      "react-dnd-compat": "static-1.3529",
      "react-immutable-proptypes": "static-2.8",
      "react-immutable-render-mixin": "static-1.9",
      "ai-settings-ui-library": "static-1.6009",
      "apollo-dlb": "static-3.41",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.3661",
      "content-icons-ui": "static-1.1917",
      "underscore": "static-1.8",
      "ui-addon-avatars": "static-2.8157",
      "ui-addon-react-router-dom": "static-1.8480",
      "usage-tracker-container": "static-1.6336"
    },
    "depPathPrefixes": {
      "unified-navigation-ui": "/unified-navigation-ui/static-1.26881",
      "ably-hubspot-js": "/ably-hubspot-js/static-2.3447",
      "breadcrumbs-ui": "/breadcrumbs-ui/static-1.2067",
      "client-types": "/client-types/static-1.375",
      "enviro": "/enviro/static-4.306",
      "head-dlb": "/head-dlb/static-1.4043",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hs-promise-utils": "/hs-promise-utils/static-1.4397",
      "hs-test-utils": "/hs-test-utils/static-1.6881",
      "hub-http": "/hub-http/static-1.4807",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3217",
      "HubStyleTokens": "/HubStyleTokens/static-2.10371",
      "I18n": "/I18n/static-7.1393",
      "jasmine-runner": "/jasmine-runner/static-1.5273",
      "nav-client-types": "/nav-client-types/static-1.1210",
      "nav-meta": "/nav-meta/static-1.25674",
      "navigation-components": "/navigation-components/static-1.14037",
      "navigation-components-tests": "/navigation-components-tests/static-1.10647",
      "navigation-messaging": "/navigation-messaging/static-1.3364",
      "quartz": "/quartz/static-1.5629",
      "react": "/react/static-7.151",
      "react-dnd": "/react-dnd/static-2.33",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
      "react-redux": "/react-redux/static-7.16",
      "redux": "/redux/static-4.16",
      "rpc-client-utils": "/rpc-client-utils/static-1.3585",
      "target-element-observer": "/target-element-observer/static-1.1108",
      "trials-service-types": "/trials-service-types/static-1.2966",
      "webpack-env": "/webpack-env/static-1.54",
      "wootric-nps": "/wootric-nps/static-1.5792",
      "ably": "/ably/static-2.2",
      "calling-internal-common": "/calling-internal-common/static-1.30106",
      "classnames": "/classnames/static-2.10",
      "crosstab": "/crosstab/static-1.3478",
      "ExtensionInstallHelpers": "/ExtensionInstallHelpers/static-1.538",
      "foundations-assets": "/foundations-assets/static-1.3795",
      "foundations-components": "/foundations-components/static-1.6080",
      "foundations-theming": "/foundations-theming/static-1-rd-fix-namespaceplugin.53",
      "foundations-theming-base": "/foundations-theming-base/static-1-rd-fix-namespaceplugin.53",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1-rd-fix-namespaceplugin.53",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.6740",
      "global-search-externals": "/global-search-externals/static-1.11693",
      "idb-keyval": "/idb-keyval/static-1.21",
      "magpie-lib": "/magpie-lib/static-1.4539",
      "magpie-types": "/magpie-types/static-1.3999",
      "metrics-js": "/metrics-js/static-1.8647",
      "nav-onboarding-tours": "/nav-onboarding-tours/static-1.2388",
      "notification-sounds": "/notification-sounds/static-1.3303",
      "prefetcher": "/prefetcher/static-1.4645",
      "react-dom": "/react-dom/static-7.85",
      "react-utils": "/react-utils/static-2.4379",
      "redux-thunk": "/redux-thunk/static-2.43",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "sanitize-text": "/sanitize-text/static-1.7045",
      "simple-logging-lib": "/simple-logging-lib/static-1.1910",
      "styled-components": "/styled-components/static-2.64",
      "superstore": "/superstore/static-1.3644",
      "trial-components-library": "/trial-components-library/static-1.11039",
      "ts-schema": "/ts-schema/static-1.3190",
      "ui-images": "/ui-images/static-2.857",
      "usage-tracker-core": "/usage-tracker-core/static-1.6196",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.4356",
      "PortalIdParser": "/PortalIdParser/static-2.284",
      "raven": "/raven/static-3.4818",
      "raven-hubspot": "/raven-hubspot/static-1.5125",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2509",
      "moment": "/moment/static-3.26",
      "quartz-core": "/quartz-core/static-1.4848",
      "storybook-react": "/storybook-react/static-1.4",
      "HeadJS": "/HeadJS/static-2.579",
      "framer-motion": "/framer-motion/static-1.41",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.1992",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.121",
      "i18n-data": "/i18n-data/static-1.198",
      "moment-timezone": "/moment-timezone/static-5.51",
      "jasmine": "/jasmine/static-4.3215",
      "quartz-core-utils": "/quartz-core-utils/static-1.2496",
      "StyleGuideUI": "/StyleGuideUI/static-3.463",
      "csstype": "/csstype/static-1.38",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "HubStyle": "/HubStyle/static-2.10679",
      "calling-error-reporting": "/calling-error-reporting/static-1.30112",
      "calling-usage-tracker": "/calling-usage-tracker/static-1.5365",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "self-service-api": "/self-service-api/static-1.9078",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.162",
      "UIComponents": "/UIComponents/static-3.7318",
      "hs-story-utils": "/hs-story-utils/static-1.8261",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2349",
      "floating-ui": "/floating-ui/static-1.29",
      "react-aria": "/react-aria/static-1.39",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.74",
      "tanstack-table": "/tanstack-table/static-1.23",
      "ui-fonts": "/ui-fonts/static-1.332",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1-rd-fix-namespaceplugin.53",
      "hub-http-janus": "/hub-http-janus/static-1.651",
      "global-search-shared": "/global-search-shared/static-1.12408",
      "usage-tracker": "/usage-tracker/static-1.6346",
      "autolinker": "/autolinker/static-3.11",
      "sanitize": "/sanitize/static-1.3257",
      "transmute": "/transmute/static-2.29",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.5340",
      "atom": "/atom/static-1.4069",
      "copilot-toolkit": "/copilot-toolkit/static-1.6748",
      "demographics-client": "/demographics-client/static-1.4277",
      "hubs-service-types": "/hubs-service-types/static-1.337",
      "icons": "/icons/static-2.592",
      "laboratory-lib": "/laboratory-lib/static-3.6122",
      "onboarding-scopes": "/onboarding-scopes/static-1.5433",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "salesImages": "/salesImages/static-1.501",
      "signup-constants": "/signup-constants/static-1.16435",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.9792",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.16127",
      "user-context": "/user-context/static-1.4047",
      "dispatcher": "/dispatcher/static-1.113",
      "general-store": "/general-store/static-6.20",
      "history": "/history/static-4.47",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.7146",
      "hubspotter-http": "/hubspotter-http/static-1.3638",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.7144",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.350",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.11286",
      "react-rhumb": "/react-rhumb/static-1.15451",
      "react-router-dom": "/react-router-dom/static-5.26",
      "cssUtils": "/cssUtils/static-1.507",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.8594",
      "ai-addon-copilot-preview": "/ai-addon-copilot-preview/static-1.4552",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.3648",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.43",
      "data-fetching-client": "/data-fetching-client/static-1.8484",
      "graphql": "/graphql/static-1.59",
      "search-service-types": "/search-service-types/static-1.2836",
      "chatspot-client-types": "/chatspot-client-types/static-1.8727",
      "chatspot-core": "/chatspot-core/static-1.15992",
      "ContentUtils": "/ContentUtils/static-1.63613",
      "sassPrefix": "/sassPrefix/static-1.132",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.3565",
      "feature-store-service-types": "/feature-store-service-types/static-1.3558",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.3565",
      "upgrade-management-service-types": "/upgrade-management-service-types/static-1.3549",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.13116",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.12234",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6750",
      "react-dnd-compat": "/react-dnd-compat/static-1.3529",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "ai-settings-ui-library": "/ai-settings-ui-library/static-1.6009",
      "apollo-dlb": "/apollo-dlb/static-3.41",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.3661",
      "content-icons-ui": "/content-icons-ui/static-1.1917",
      "underscore": "/underscore/static-1.8",
      "ui-addon-avatars": "/ui-addon-avatars/static-2.8157",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.8480",
      "usage-tracker-container": "/usage-tracker-container/static-1.6336"
    },
    "project": "unified-navigation-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};